<template>
  <!-- 每月目标表单 -->
  <el-form ref="form" :model="form1" label-width="100px">
    <el-row>
      <el-col span="12">
        <el-form-item label="项目" :required="true">
          <el-select
            clearable
            filterable
            v-model="form.mautoid"
            placeholder="请选项目"
          >
            <el-option
              v-for="item in tboptions.mautoid"
              :key="item.autoid"
              :label="item.name + '-' + item.ctname"
              :value="item.autoid"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col span="12">
        <el-form-item label="考核得分">
          <el-input v-model="form.cost"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item label="考核内容" v-show="false">
      <el-input v-model="form.contant" type="textarea" rows="5"></el-input>
    </el-form-item>
    <el-form-item label="实际完成情况" v-show="false">
      <el-input v-model="form.condition" type="textarea" rows="5"></el-input>
    </el-form-item>

    <div v-for="(item, idx) in detail" :key="idx" v-show="item.isactive == 1">
      <div class="table_operate">
        <span :title="'删除'" @click="item.isactive = 0 ">
          <svg-icon :icon-class="'advancedQueryDelete'" />
        </span>
      </div>

      <el-form-item :label="'考核内容' + (idx + 1)" :required="true">
        <el-input v-model="item.contant"></el-input>
      </el-form-item>
      <el-form-item :label="'实际完成情况' + (idx + 1)" :required="true">
        <el-input v-model="item.condition"></el-input>
      </el-form-item>
      <el-row>
        <el-col span="12">
          <el-form-item :label="'考核类型' + (idx + 1)" :required="true">
            <el-select
              clearable
              filterable
              v-model="item.khtype"
              placeholder="请选考核类型"
            >
              <el-option
                v-for="o in ty"
                :key="o.value"
                :label="o.label"
                :value="o.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="12">
          <el-form-item :label="'是否完成' + (idx + 1)" :required="true">
            <el-switch v-model="item.finshin"></el-switch>
          </el-form-item> </el-col
      ></el-row>
    </div>
    <div class="addpar">
      <el-button type="primary" size="small" class="add" @click="add()">
        新增指标
      </el-button>
    </div>
  </el-form>
</template>

<script>
export default {
  props: {
    tboptions: {
      // 下拉选项
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      form: {},
      form1: {},
      detail: [],
      ty: [
        { label: '调研        交付物：调研报告', value: '调研' },
        { label: '模块测试    交付物：上线测试报告', value: '模块测试' },
        { label: '模块上线	   交付物：上线报告', value: '模块上线' },
        { label: '模块验收    交付物：模块验收报告', value: '模块验收' },
        { label: '项目验收    交付物：验收报告', value: '项目验收' },
        { label: '收款', value: '收款' }
      ]
    }
  },
  methods: {
    add() {
      this.detail.push({
        autoid: 0,
        condition: '',
        contant: '',
        khtype: '',
        finshin: false,
        isactive: 1
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@/styles/mixin.scss';
.el-form {
  height: 580px;
  overflow-y: auto;
  .table_operate {
    display: flex;
    justify-content: flex-end;
    padding: 10px;
  }
  .shzt {
    height: 42px;
    line-height: 42px;
    padding: 0 20px;
    font-weight: bold;
    span {
      color: #1b6aaa;
    }
  }
  /deep/ .el-form-item {
    .el-form-item__label {
      font-weight: bold;
    }
  }
  .addpar {
    text-align: center;
  }
}
</style>
